import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { fetchTopResults, TOP_RESULTS_QUERY_KEY } from "@/features/strateg-cenowy/top/api/results";
import { WynikiTopPage } from "@/features/strateg-cenowy/top/components/WynikiTopPage";
import { ensureElementVisible } from "@/lib/route-guards";

// `?openImport=1` deep-link otwiera TopImportDialog (Unit 12). `?scope=apteka:123`
// jest spojny ze starym /wyniki — ScopePicker hydrate'uje persisted state, ale
// param URL wygrywa pierwszy raz.
const searchSchema = z.object({
	scope: z.string().optional(),
	openImport: z.coerce.number().optional(),
	// Tryb pracy (zakładka): "all" = wszystkie produkty, "zalegacze-wlasne" =
	// operacyjna zakładka wyprzedaży (atrybut 3003). Persistowany w URL —
	// F5/share zachowuje wybrany widok. Filtrowanie wierszy zyje WYLACZNIE
	// w filtrach kolumnowych DataTable (bez duplikatu w URL).
	view: z.enum(["all", "zalegacze-wlasne"]).optional(),
	// zod 4: `.catch()` nie robi juz klucza opcjonalnym w typie wejscia, wiec bez
	// `.default(10)` kazda nawigacja na te trase musialaby podawac minQty30.
	// Brak klucza i wartosc bledna nadal daja 10, jak w zod 3.
	minQty30: z.coerce.number().int().nonnegative().default(10).catch(10),
});

export const Route = createFileRoute("/_auth/strateg-cenowy/wyniki-top")({
	validateSearch: searchSchema,
	beforeLoad: async ({ context }) => {
		// element_id MUSI byc dokladnie taki sam jak sidebar-config wpis (feedback
		// `feedback_route_guard_sidebar_parity.md`) — prefix `sidebar.` jest obowiazkowy.
		await ensureElementVisible(context.queryClient, "sidebar.strateg-cenowy.wyniki-top");
	},
	loaderDeps: ({ search }) => ({ view: search.view }),
	loader: ({ context: { queryClient }, deps }) => {
		// Non-blocking prefetch — `defaultPreload: 'intent'` w main.tsx zaczyna
		// fetch na hover linku. Bez `loader:` prefetch nie dziala dla tej route.
		// Performance-engineer audit 2026-05-26: oszczednosc 200-400ms TTFD.
		// QueryKey MUSI byc identyczny z useTopResults({}) z `top/api/results.ts:67`.
		if (deps.view === "zalegacze-wlasne") return;
		const params = {};
		queryClient.ensureQueryData({
			queryKey: [...TOP_RESULTS_QUERY_KEY, "page", params] as const,
			queryFn: () => fetchTopResults({ limit: 5000 }, 0),
			staleTime: 5 * 60_000,
		});
	},
	component: WynikiTopPage,
});
